export default "__VITE_ASSET__YmBvdOPl__"